import { BeckyModel } from '../../types'

export function deStringifyExperiments(beckyExperiments: string | undefined): BeckyModel['experiments'] {
	if (!beckyExperiments) {
		return {}
	}

	const experiments = beckyExperiments.split(',').reduce((acc, exp) => {
		const expKeyAndValue = exp.split(':')
		return {
			...acc,
			[expKeyAndValue[0]]: expKeyAndValue[1],
		}
	}, {})

	return fixExperimentsValues(experiments)
}

export const fixExperimentsValues = (experiments: BeckyModel['experiments']) => {
	return Object.entries(experiments).reduce(
		(acc, [key, value]) => ({
			...acc,
			[key]: value === 'new' || value === 'true' ? true : value,
		}),
		{}
	)
}
